import { Controller } from '@hotwired/stimulus';
import { debounce } from '../../utilities/debounce';

export default class extends Controller {
  private readonly FOCUS_DEBOUNCE_TIME = 50;

  initialize() {
    window.addEventListener(
      'turbo:load',
      debounce(() => this.setFocus(), this.FOCUS_DEBOUNCE_TIME),
      { once: true },
    );
  }

  setFocus() {
    const targetElement = this.element.querySelector(
      ':invalid:enabled, [aria-invalid="true"]',
    ) as HTMLElement;
    targetElement?.focus();
  }
}
